import React from "react";

function Mini_carousel1() {
  
  const options = {
    rtl: false, // Enable right-to-left direction
    loop: true, // Enable infinite looping
    margin: 10, // Space between items
    nav: true, // Show navigation arrows
    autoplay: true, // Enable autoplay
    autoplayTimeout: 3000, // Autoplay interval (ms)
    items: 5, // Number of visible items
  };

  const slide_img = [
    {
      imgSrc: "assets/images/Slide/13.png",
    },
    {
      imgSrc: "assets/images/Slide/11.png",
    },
    {
      imgSrc: "assets/images/Slide/7.png",
    },
    {
      imgSrc: "assets/images/Slide/6.png",
    },
    {
      imgSrc: "assets/images/Slide/5.png",
    },
    {
      imgSrc: "assets/images/Slide/3.png",
    },
  ];

  return (
    <div class="owl-carousel owl-theme" {...options}>
      {slide_img.map((slides_img, index) => (
        <div class="item owl-slide-mini" key={index}>
          <img
            style={{ aspectRatio: "1/1", mixBlendMode: "multiply" }}
            src={slides_img.imgSrc}
            alt="First slide"
          />
        </div>
      ))}
    </div>
  );
}

export default Mini_carousel1;








